// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product .product__thumbnail[data-v-05386ca8]:before{display:none!important}.swiper-container-horizontal>.swiper-pagination-bullets[data-v-05386ca8],.swiper-pagination-custom[data-v-05386ca8],.swiper-pagination-fraction[data-v-05386ca8]{bottom:0;margin-bottom:5px}", ""]);
// Exports
module.exports = exports;
